import { render, staticRenderFns } from "./BasePaneCard.vue?vue&type=template&id=6e708bb8&scoped=true&"
import script from "./BasePaneCard.vue?vue&type=script&lang=js&"
export * from "./BasePaneCard.vue?vue&type=script&lang=js&"
import style0 from "./BasePaneCard.vue?vue&type=style&index=0&id=6e708bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e708bb8",
  null
  
)

export default component.exports